import { parseDateTime } from "../../helpers/parseDateTime";

const getMinutes = (isoString) => {
  if (!isoString) return Number.POSITIVE_INFINITY;
  try {
    const d = new Date(isoString);
    if (isNaN(d.getTime())) return Number.POSITIVE_INFINITY;
    return d.getTime();
  } catch (e) {
    return Number.POSITIVE_INFINITY;
  }
};

export const formatConnectionTimes = (connection) => {
  const isOutbound = connection.direction === "outbound";

  const scheduledIso = isOutbound
    ? connection.departureTime
    : connection.arrivalTime;
  const estimatedIso = isOutbound
    ? connection.estimatedDepartureTime
    : connection.estimatedArrivalTime;
  const actualIso = isOutbound
    ? connection.actualDepartureTime
    : connection.actualArrivalTime;

  const qualifier = isOutbound
    ? connection.departureTimeQualifier
    : connection.arrivalTimeQualifier;

  const scheduled = scheduledIso ? parseDateTime(scheduledIso) : null;
  const estimated = estimatedIso ? parseDateTime(estimatedIso) : null;
  const actual = actualIso ? parseDateTime(actualIso) : null;

  const chips = [];
  if (qualifier && scheduled) {
    chips.push(`${qualifier} ${scheduled.time}`);
  } else if (scheduled) {
    chips.push(`${isOutbound ? "STD" : "STA"} ${scheduled.time}`);
  }
  if (estimated) {
    const skip =
      (isOutbound && qualifier === "ETD") ||
      (!isOutbound && qualifier === "ETA");
    if (!skip) chips.push(`${isOutbound ? "ETD" : "ETA"} ${estimated.time}`);
  }
  if (actual) {
    const skip =
      (isOutbound && qualifier === "ATD") ||
      (!isOutbound && qualifier === "ATA");
    if (!skip) chips.push(`${isOutbound ? "ATD" : "ATA"} ${actual.time}`);
  }

  return { label: chips.join(" "), chips };
};

export const filterByDirection = (connections, mode) => {
  if (mode === "INBOUND")
    return (connections || []).filter((c) => c.direction === "inbound");
  if (mode === "OUTBOUND")
    return (connections || []).filter((c) => c.direction === "outbound");
  return Array.isArray(connections) ? connections : [];
};

export const sortConnections = (connections) => {
  const score = (c) => (c.direction === "inbound" ? 0 : 1);
  const timeValue = (c) => {
    const scheduled =
      c.direction === "outbound" ? c.departureTime : c.arrivalTime;
    const estimated =
      c.direction === "outbound"
        ? c.estimatedDepartureTime
        : c.estimatedArrivalTime;
    const actual =
      c.direction === "outbound" ? c.actualDepartureTime : c.actualArrivalTime;
    const s = getMinutes(scheduled);
    const e = getMinutes(estimated);
    const a = getMinutes(actual);
    if (isFinite(s)) return s; // Prefer scheduled
    if (isFinite(e)) return e; // Fallback to estimated
    return a; // Then actual
  };
  return [...(connections || [])].sort((a, b) => {
    const dir = score(a) - score(b);
    if (dir !== 0) return dir;
    return timeValue(a) - timeValue(b);
  });
};
